// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"53f3162c","34":"94fcd36b","169":"e124bf44","175":"304d14d7","833":"8d760fc5","839":"bc511063","862":"750ebcc4","887":"19b933ef"}[chunkId] + ".chunk.js";
};